import { useState } from 'react';
import { HelpCircle, MessageSquare, Clock, FileText, Users, User } from 'lucide-react';
import { Markdown } from '../lib/markdown';
import introMd from '../help/intro.md?raw';
import agentMd from '../help/agent.md?raw';
import clientMd from '../help/client.md?raw';
import maxBotMd from '../help/max-bot.md?raw';
import slaMd from '../help/sla.md?raw';
import changelogMd from '../help/changelog.md?raw';

const SECTIONS: { id: string; title: string; icon: any; md: string }[] = [
  { id: 'intro',     title: 'Введение',           icon: HelpCircle,    md: introMd },
  { id: 'agent',     title: 'Для сотрудника',     icon: Users,         md: agentMd },
  { id: 'client',    title: 'Для клиента',        icon: User,          md: clientMd },
  { id: 'max-bot',   title: 'MAX-бот',             icon: MessageSquare, md: maxBotMd },
  { id: 'sla',       title: 'SLA',                 icon: Clock,         md: slaMd },
  { id: 'changelog', title: 'Релиз-ноуты',         icon: FileText,      md: changelogMd },
];

export default function HelpPage() {
  const [active, setActive] = useState(SECTIONS[0].id);
  const section = SECTIONS.find(s => s.id === active) || SECTIONS[0];
  return (
    <div className="grid grid-cols-[220px_1fr] gap-4">
      <nav className="bg-slate-900 border border-slate-800 rounded-xl p-2 self-start">
        {SECTIONS.map(s => {
          const Icon = s.icon;
          return (
            <button key={s.id} onClick={() => setActive(s.id)}
              className={`w-full text-left px-3 py-2 rounded text-sm flex items-center gap-2 transition ${
                active === s.id ? 'bg-blue-600 text-white font-bold' : 'text-slate-300 hover:bg-slate-800'
              }`}>
              <Icon size={14} /> {s.title}
            </button>
          );
        })}
      </nav>
      <article className="bg-slate-900 border border-slate-800 rounded-xl p-6 max-w-3xl">
        <Markdown source={section.md} />
      </article>
    </div>
  );
}
